<template>
    <b-tab
        :title-link-attributes="linkAttributes"
        :title-item-class="lineClass"
        :disabled="disabled"
        :active="active"
    >
        <template #title>
            <span class="timeline-tab-title" :data-time="dateTimeText">{{ title }}</span>
        </template>
        <slot></slot>
    </b-tab>
</template>

<script>
import { BTab } from 'bootstrap-vue'

export default {
    components: { BTab },
    props: {
        label: {type: String, default: ''},
        dateTime: {type: String, default: ''},
        dateTimeSufix: {type: String, default: 'h'},
        title: {type: String, default: ''},
        lineClass: {type: [Array, Object, String], default: ''},
        classificacaoRisco: {type: String, default: ''},
        disabled: {type: Boolean, default: false},
        active: {type: Boolean},
    },
    computed: {
        linkAttributes() {
            const attributes = {}
            if(this.label) attributes['data-info'] = this.label
            return attributes
        },
        dateTimeText() {

            let text = this.dateTime

            if (this.dateTimeSufix) {

                text += ` ${this.dateTimeSufix}`
            }

            return text
        }
    },
}
</script>

<style type="text/css">
    .timeline-tabs > li {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        position: relative;
        margin: 0 !important;
        float: none;
        color: #333;
    }
    .timeline-tabs > li:not(:last-child):before {
        content: '';
        position: absolute;
        top: calc(50% - 1px);
        left: 50%;
        width: 100%;
        height: 2px;
        background: currentColor;
    }
    .timeline-tabs > li > a, .timeline-tabs > li > a:hover,
    .timeline-tabs > li > a.active, .timeline-tabs > li > a.active:hover,
    .timeline-tabs > li > a.nav-link, .timeline-tabs > li > a.nav-link:hover {
        color: currentColor !important;
        border: none !important;
        background: none !important;
        text-align: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-direction: column;
        height: 70px;
        padding: 0;
    }
    .timeline-tabs > li > a[data-info]:before {
        content: attr(data-info);
        width: 80px;
        background: #f1f4f6;
        z-index: 2;
        line-height: 1;
        height: 23px;
        padding: 0.2rem 0;
        font-weight: 500;
    }
    .timeline-tabs > li > a[data-info]:after {
        width: 37px;
        height: 14px;
    }
    .timeline-tabs > li > a:before, .timeline-tabs > li > a:after {
        content: '';
        width: 12px;
        height: 12px;
        border-radius: 10px;
        background: currentColor;
        border: 2px solid currentColor;
        margin: auto;
        display: inline-block;
    }
    .timeline-tabs > li > a:after {
        -webkit-transform: scale(0);
        transform: scale(0);
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%) scale(0);
        transform: translateX(-50%) translateY(-50%) scale(0);
        width: 12px;
        height: 12px;
        background: #FFF;
        border: 4px solid currentColor;
        opacity: 0.3;
        -webkit-transition: -webkit-transform 0.3s;
        transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
        transition: transform 0.3s, -webkit-transform 0.3s;
    }

    .timeline-tabs > li > a.active:after {
        -webkit-transform: translateX(-50%) translateY(-50%) scale(2.5);
                transform: translateX(-50%) translateY(-50%) scale(2.5);
    }

    .timeline-tabs > li > a > span {
        bottom: auto;
        top: 0;
    }
    .timeline-tabs > li > a > span {
        position: absolute;
        top: -4px;
        left: 50%;
        -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
        bottom: 0;
        color: #333 !important;
        -webkit-box-shadow: 0px 0px 0px 0px currentColor;
                box-shadow: 0px 0px 0px 0px currentColor;
        -webkit-transition: -webkit-box-shadow 0.3s;
        transition: -webkit-box-shadow 0.3s;
        transition: box-shadow 0.3s;
        transition: box-shadow 0.3s, -webkit-box-shadow 0.3s;
        white-space: nowrap;
    }
    .timeline-tabs > li > a > span:after {
        position: absolute;
        bottom: 0;
        left: 50%;
        content: attr(data-time);
        font-size: 10px;
        transform: translateX(-50%);
    }
    .timeline-tabs > li > a.active:before {
        -webkit-box-shadow: 0px 0px 10px -5px currentColor;
                box-shadow: 0px 0px 10px -5px currentColor;
    }
    .timeline-tabs > li > a.active > span {
        font-weight: 600;
    }
</style>


